const queryString = require("query-string");
import fillFormFields from './fill-form-fields';
import retrieveContactData from './retrieve-contact-data';
import validateFormExternalSubmit from './validateFormExternalSubmit';

(window.onpopstate = function () {
    console.log("multistep-form window.onpopstate");

    // console.log("location.search: ", location.search);

    let urlParams = queryString.parse(location.search, {arrayFormat: "index"});

    if ("invitee_full_name" in urlParams)
    {
        urlParams.first_name = urlParams.invitee_full_name;
        urlParams.last_name = "";
    }

    fillFormFields(urlParams);
    retrieveContactData(urlParams);
})();

console.log("multistep-form load");
window.validateAndSubmitPulseForm = validateFormExternalSubmit;





// WEBPACK FOOTER //
// ./app/Modules/FormBuilder/resources/assets/js/multistep-form.js